import { GuideModule } from "@/api/guides";

const EXACT_MATCH: Record<string, GuideModule> = {
  "/": "home_dashboard",
  "/dashboard": "appointments",
};

const PREFIX_MATCH: [string, GuideModule][] = [
  ["/cases", "cases"],
  ["/clients", "clients"],
  ["/invoices", "invoicing"],
  ["/expenses", "expenses"],
  ["/adversaries", "adversaries"],
  ["/honoraires", "fees"],
  ["/affectation", "lawyer_assignment"],
  ["/external-lawyers", "external_lawyers"],
  ["/chatbot", "ai_assistant"],
  ["/users", "team_permissions"],
  ["/cabinet-roles", "team_permissions"],
  ["/profile", "settings"],
  ["/lawyer-profile", "settings"],
  ["/cabinet-settings", "settings"],
  ["/cabinet-plans", "settings"],
  ["/cabinet-subscriptions", "settings"],
  ["/cabinet-billing", "settings"],
];

export const getModuleFromPathname = (pathname: string): GuideModule | null => {
  if (pathname in EXACT_MATCH) return EXACT_MATCH[pathname];

  const match = PREFIX_MATCH.find(([prefix]) => pathname.startsWith(prefix));
  return match ? match[1] : null;
};
